var _path, _g, _path2, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClearGrouping(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1592_63051)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1592_63051",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 2,
    width: 16,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 2H0V18H16V2Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1592_63051)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 2V18H16V2H0ZM15.0625 2.9375V3.875H0.9375V2.9375H15.0625ZM0.9375 17.0625V4.8125H15.0625V17.0625H0.9375Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.54 11.1699H11.208V10.4824C11.208 9.88419 10.7213 9.39747 10.123 9.39747H8.791V8.70997C8.791 8.11172 8.30428 7.625 7.70603 7.625H3.45997C2.86172 7.625 2.375 8.11172 2.375 8.70997V11.4951C2.375 12.0934 2.86172 12.5801 3.45997 12.5801H4.792V13.2676C4.792 13.8658 5.27872 14.3526 5.87697 14.3526H7.209V15.0401C7.209 15.6383 7.69572 16.125 8.29397 16.125H12.5401C13.1383 16.125 13.625 15.6383 13.625 15.04V12.2549C13.625 11.6567 13.1383 11.1699 12.54 11.1699ZM3.45997 11.6426C3.37866 11.6426 3.3125 11.5764 3.3125 11.4951V8.70994C3.3125 8.62863 3.37866 8.56247 3.45997 8.56247H7.70606C7.78737 8.56247 7.85353 8.62863 7.85353 8.70994V9.39744H5.87697C5.27872 9.39744 4.792 9.88416 4.792 10.4824V11.6426H3.45997ZM5.87694 13.415C5.79562 13.415 5.72947 13.3489 5.72947 13.2676V10.4824C5.72947 10.4011 5.79562 10.3349 5.87694 10.3349H10.123C10.2043 10.3349 10.2705 10.4011 10.2705 10.4824V11.1699H8.29394C7.69569 11.1699 7.20897 11.6566 7.20897 12.2549V13.415H5.87694ZM12.6875 15.04C12.6875 15.1213 12.6213 15.1875 12.54 15.1875H8.29394C8.21263 15.1875 8.14647 15.1213 8.14647 15.04V12.2549C8.14647 12.1736 8.21263 12.1074 8.29394 12.1074H12.54C12.6213 12.1074 12.6875 12.1736 12.6875 12.2549V15.04Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.34375 5.75H10.7188V6.6875H4.34375V5.75Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.875 5.75H3.40625V6.6875H1.875V5.75Z",
    fill: "current"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1592_63051",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 8,
    height: 8
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 0H12V8H20V0Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1592_63051)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8433 7.92383C17.8928 7.92383 19.5542 6.25145 19.5542 4.18848C19.5542 2.1255 17.8928 0.453125 15.8433 0.453125C13.7938 0.453125 12.1323 2.1255 12.1323 4.18848C12.1323 6.25145 13.7938 7.92383 15.8433 7.92383Z",
    fill: "#EE404C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3572 5.67416C14.3955 5.71331 14.4412 5.7444 14.4916 5.76562C14.542 5.78684 14.5961 5.79777 14.6508 5.79777C14.7054 5.79777 14.7595 5.78684 14.8099 5.76562C14.8603 5.7444 14.906 5.71331 14.9443 5.67416L15.8333 4.77934L16.7223 5.67416C16.8001 5.75254 16.9057 5.79657 17.0159 5.79657C17.126 5.79657 17.2316 5.75254 17.3094 5.67416C17.3873 5.59579 17.431 5.48949 17.431 5.37865C17.431 5.26782 17.3873 5.16152 17.3094 5.08315L16.4205 4.18832L17.3094 3.2935C17.348 3.25469 17.3786 3.20862 17.3994 3.15792C17.4203 3.10721 17.431 3.05287 17.431 2.99799C17.431 2.94311 17.4203 2.88876 17.3994 2.83806C17.3786 2.78736 17.348 2.74129 17.3094 2.70248C17.2709 2.66367 17.2251 2.63289 17.1747 2.61189C17.1244 2.59089 17.0704 2.58008 17.0159 2.58008C16.9613 2.58008 16.9073 2.59089 16.857 2.61189C16.8066 2.63289 16.7608 2.66367 16.7223 2.70248L15.8333 3.59731L14.9443 2.70248C14.9058 2.66367 14.86 2.63289 14.8096 2.61189C14.7593 2.59089 14.7053 2.58008 14.6508 2.58008C14.5962 2.58008 14.5422 2.59089 14.4919 2.61189C14.4415 2.63289 14.3957 2.66367 14.3572 2.70248C14.3186 2.74129 14.288 2.78736 14.2672 2.83806C14.2463 2.88876 14.2356 2.94311 14.2356 2.99799C14.2356 3.05287 14.2463 3.10721 14.2672 3.15792C14.288 3.20862 14.3186 3.25469 14.3572 3.2935L15.2462 4.18832L14.3572 5.08315C14.3183 5.12176 14.2874 5.16776 14.2663 5.21849C14.2452 5.26922 14.2344 5.32366 14.2344 5.37865C14.2344 5.43364 14.2452 5.48808 14.2663 5.53881C14.2874 5.58954 14.3183 5.63555 14.3572 5.67416Z",
    fill: "#FFF7ED"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1592_63051"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearGrouping);
export default __webpack_public_path__ + "static/media/ClearGrouping.da72a3d60827c6a8e6885b4f94462265.svg";
export { ForwardRef as ReactComponent };